// extracted by mini-css-extract-plugin
export default {"container":"TableTwoDiseaseKnowledge_container__z98y9","title":"TableTwoDiseaseKnowledge_title__06zuz"};